module.exports = __webpack_public_path__ + "static/media/yassine_1.aa50e985.jpg";